import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import YouxiZixun from "../pages/youxi-zixun/page";
import LiandongQingbao from "../pages/liandong-qingbao/page";
import XinyouManhuahu from "../pages/xinyou-manhuahu/page";
import BanbenGengxin from "../pages/banben-gengxin/page";
import ArticleDetail from "../pages/article/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/youxi-zixun", element: <YouxiZixun /> },
  { path: "/liandong-qingbao", element: <LiandongQingbao /> },
  { path: "/xinyou-manhuahu", element: <XinyouManhuahu /> },
  { path: "/banben-gengxin", element: <BanbenGengxin /> },
  { path: "/article/:slug", element: <ArticleDetail /> },
  { path: "/about", element: <About /> },
  { path: "/contact", element: <Contact /> },
  { path: "*", element: <NotFound /> },
];

export default routes;